let getters = {
  loading(state){
    return state.loading
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/request/getters.js